// extracted by mini-css-extract-plugin
export default {"sessionExpiredPageWrapper":"styles_sessionExpiredPageWrapper__EiX8-","pageContent":"styles_pageContent__TPkZe","textBlock":"styles_textBlock__ItVgV","redBtn":"styles_redBtn__bbM66"};